import { Moment } from "moment";

interface Fields {
  date_cmr?: Moment;
  creation_date?: Moment;
}

const normalize = (fields: Fields): Object => ({
  ...fields,
  creation_date: fields.creation_date
    ? fields.creation_date.format("YYYY-MM-DD")
    : null,
  date_cmr: fields.date_cmr ? fields.date_cmr.format("YYYY-MM-DD") : null,
});

export default normalize;
